(() => {
    const GIFT_KEY = "_is_gift_card";

    async function updateCart() {
        const rows = [...document.querySelectorAll(".ms__multishipping-cart .ms__group-wrapper .ms__cart-row")];
        const cart = await (await fetch("/cart.js")).json();

        cart.items.forEach((item, i) => {
            const row = rows.find(r => +r.dataset.line === i + 1);
            if (!row) return;

            const isGift = item.properties?.[GIFT_KEY] === "true";

            // Create gift checkbox
            const giftOption = Object.assign(document.createElement("div"), { className: "gift-checkbox" });
            const label = Object.assign(document.createElement("label"), { innerText: window.cartStrings.gift_checkbox_label || "Send as a gift", htmlFor: `gift-option-${i}` });
            const checkbox = Object.assign(document.createElement("input"), {
                id: `gift-option-${i}`,
                type: "checkbox",
                name: "is_gift_card",
                value: "true",
                checked: isGift,
            });

            checkbox.onchange = () => {
                let props = { ...item.properties };
                if (checkbox.checked) props[GIFT_KEY] = "true";
                else delete props[GIFT_KEY];

                fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: item.key, properties: props })
                }).then(() => location.reload());
            };

            giftOption.appendChild(checkbox);
            giftOption.appendChild(label);
            row.prepend(giftOption);
        });
    }

    updateCart();

    const container = document.querySelector("#msGroups");
    if (container) {
        new MutationObserver(muts => {
            if (muts.some(m => m.target.id === "msGroupsBox")) updateCart();
        }).observe(container, { childList: true, subtree: true });
    } else {
        console.warn("Cart container not found.");
    }
})();